import { ApiController } from 'config';
import { t } from 'i18next';
import { get, post } from 'services';
import { showErrorAlert } from 'redux/utils';
import { IFavoritesResponse } from 'interfaces';
import type { Dispatch } from 'redux';
import { LocalStorageKey } from 'config/localStorage.constants';

export const getFavoritesAddedTimestamps = (): Record<number, string> => {
  try {
    const stored = localStorage.getItem(LocalStorageKey.favoritesAddedAt);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

export const updateFavoriteTimestamp = (
  discountId: number,
  isFavorite: boolean,
) => {
  const timestamps = getFavoritesAddedTimestamps();
  if (isFavorite) {
    timestamps[discountId] = new Date().toISOString();
  } else {
    delete timestamps[discountId];
  }
  localStorage.setItem(
    LocalStorageKey.favoritesAddedAt,
    JSON.stringify(timestamps),
  );
};

export const getfavoriteDiscountsIds = async (
  dispatch: Dispatch,
): Promise<number[]> => {
  try {
    const response = await get<{ content: { id: number }[] }>({
      url: `${ApiController.favorites}?size=1000`,
    });
    return response?.content?.map((discount) => discount.id) ?? [];
  } catch (error) {
    showErrorAlert(
      dispatch,
      error,
      t('alert.ERRORS.favorite_fetch_error.title'),
    );
    return [];
  }
};

export const toggleFavoriteDiscount = async (
  discountId: number,
  dispatch: Dispatch,
): Promise<void> => {
  try {
    const currentFavoritesBeforeToggle = await getfavoriteDiscountsIds(
      dispatch,
    );
    const isCurrentlyFavorite =
      currentFavoritesBeforeToggle.includes(discountId);

    await post({ url: `${ApiController.favorites}/${discountId}/toggle` });

    updateFavoriteTimestamp(discountId, !isCurrentlyFavorite);
  } catch (error) {
    showErrorAlert(
      dispatch,
      error,
      t('alert.ERRORS.favorite_sync_error.title'),
    );
    throw error;
  }
};

export const getFavoriteDiscountsData = async (
  locationId: number,
  page: number,
  size: number,
): Promise<IFavoritesResponse> => {
  const response = await get<IFavoritesResponse>({
    url: `${ApiController.favorites}?size=${size}&page=${page}&locationId=${locationId}`,
  });

  if (!response?.content)
    return { content: [], last: true, size: 0, totalElements: 0 };

  return response;
};
